import { UserController, SettingsController, CustomerController } from '../../controllers';
import { appStore, businessStore, useStores } from '../../stores';
import { MimaToastUtil } from '../../components';
import { useNavigate } from 'react-router-dom';
import constant from '../../utils/constant';
import { observer } from 'mobx-react';
import { Login } from '../../pages';
import * as yup from 'yup';
import React, { useState } from 'react';
import { toJS } from 'mobx';
import { navigateToFirstRoute } from '../../utils/utils';

const LoginContainer = () => {
	const [loading, setLoading] = useState(false);

	const navigate = useNavigate();

	const validationSchema = () =>
		yup.object({
			email: yup
				.string()
				.trim()
				.email('Enter a valid Email')
				.required('Email Address is required'),
			password: yup.string().required('Password is required'),
		});


		const onSubmit = async (values) => {
			setLoading(true);
			const payload = {
				adminEmailMobile: values.email,
				password: values.password
			}
	
			const { status, errorMessage, errorCode } = await UserController.login(payload);
	
			if (status === constant.Success) {
				setLoading(false)
				return navigate(constant.Routes.AdminDashboard);
			} else {
				setLoading(false)
				MimaToastUtil.error({
					message: errorMessage
				})
			}
	
			
		}

	return (
		<div>
			<Login
				validationSchema={validationSchema}
				onSubmit={onSubmit}
				loading={loading}
			/>
		</div>
	);
};

export default observer(LoginContainer);
